'use client'

import { cva } from 'cva'
import type { ReactNode } from 'react'

import { cn } from '../../lib'
import ChipV3 from './chip-v3'
import type { ChipV3Props } from './chip-v3.types'

export type ChipWithBadgeV3Props = ChipV3Props & {
  badge?: ReactNode
  badgeText?: string
  badgeColor?: 'red' | 'blue'
}

const badgeStyle = cva({
  base: 'px-2 py-px h-5 text-[10px] font-semibold flex items-center',
  variants: {
    color: {
      red: 'bg-red-normal text-white',
      blue: 'bg-blue-normal text-white',
    },
  },
  defaultVariants: {
    color: 'red',
  },
})

const ChipWithBadgeV3 = ({
  className,
  children,
  badge,
  badgeText,
  badgeColor = 'red',
  ...props
}: ChipWithBadgeV3Props) => {
  const renderBadge = () => {
    if (badge) {
      return badge
    }
    if (!badgeText) {
      return null
    }

    return <div className={badgeStyle({ color: badgeColor })}>{badgeText}</div>
  }

  const badgeElement = renderBadge()

  return (
    <div className="relative flex-1">
      <ChipV3 {...props} className={cn('w-full', className)}>
        {children}
      </ChipV3>
      {badgeElement && (
        <div className="absolute top-[-1px] right-0 overflow-hidden pointer-events-none rounded-[4px_12px_0_4px]">
          {badgeElement}
        </div>
      )}
    </div>
  )
}

ChipWithBadgeV3.displayName = 'ChipWithBadgeV3'

export default ChipWithBadgeV3
